import { SelectInputV2, TextInput } from '@frontend/components/basic-forms';
import { ICONS } from '@frontend/icons';
import { ListInfo } from '@frontend/repository';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import React from 'react';
import { useIntl } from 'react-intl';

import { useInsaneSearch } from './insane-search.controller';

export interface InsaneSearchProps {
    searchKeys: string[];
    displayName?: Map<string, React.ReactNode>;
    listId: string;
    listStore: ListInfo;
    dispatch: ThunkDispatch<any, any, Action>;
}

export const InsaneSearch = (props: InsaneSearchProps) => {
    const intl = useIntl();
    const viewProps = useInsaneSearch(props);
    const singleOption = viewProps.options.length <= 1;

    return (
        <div className='outline-border-default flex h-11 w-full min-w-0 self-stretch overflow-hidden rounded-md outline-1 outline-offset-[-1px] 2xl:w-1/3'>
            <div className='bg-background-surface flex h-full w-48 shrink-0 items-stretch'>
                <SelectInputV2
                    selectContainerClassName='h-full w-full'
                    selectClassName={`flex h-full w-full items-center justify-start gap-2 px-4 font-medium whitespace-nowrap ${singleOption ? 'cursor-default' : 'cursor-pointer'}`}
                    className='h-full w-full gap-0 p-0'
                    options={viewProps.options}
                    value={viewProps.selectOption}
                    onSelect={(value) => viewProps.setSelectOption(value ? value.value : '')}
                    disableSearch
                    disabled={singleOption}
                />
            </div>
            <div className='border-border-default min-w-40 flex-1 border-x'>
                <TextInput
                    placeholder={intl.formatMessage({ defaultMessage: 'Search', id: 'common.search', description: 'Search placeholder' })}
                    inputClassName='bg-background-surface flex h-full w-full items-center justify-start gap-3 overflow-hidden border-0 px-3 m-0'
                    className='m-0 h-full w-full gap-0 p-0'
                    value={viewProps.value}
                    onChange={viewProps.setValue}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            viewProps.onChange();
                        }
                    }}
                />
            </div>
            <div
                onClick={viewProps.onChange}
                className='bg-background-surface text-foreground-default hover:text-brand-primary flex h-full w-14 shrink-0 cursor-pointer items-center justify-center gap-2 p-3'>
                <ICONS.BUTTON.SEARCH className='size-5' />
            </div>
        </div>
    );
};
